import { RouteType } from '../utils/types';

export const simpleCompare = (obj, elem) => obj === elem;

export const unique = <T extends object>(
  data: T[],
  compareFn: (obj: T, elem: T) => boolean = simpleCompare,
): T[] => {
  return data.filter(
    (elem, pos, arr) => arr.findIndex((obj) => compareFn(obj, elem)) === pos,
  );
};

let myRoutes = [];

export const clearRoutes = () => {
  myRoutes = [];
};

export const appendRoutes = (routes: RouteType) => {
  myRoutes = unique([...myRoutes, routes]);

  return myRoutes;
};

export const getRoutes = () => {
  return myRoutes;
};

export type RouteName = string;
